document.addEventListener('DOMContentLoaded', () => {
  const infos = document.querySelectorAll('.template-article .cta-info');
  infos.forEach((info) => {
    // Aynı satır önceden eklenmişse tekrar ekleme
    if (info.nextElementSibling && info.nextElementSibling.classList.contains('cta-legal')) return;

    const legal = document.createElement('div');
    legal.className = 'cta-legal';
    legal.innerHTML = `
      <a href="/policies/refund-policy">30-Day Return Policy</a> ·
      <a href="/policies/shipping-policy">Shipping Info</a>
    `;
    info.insertAdjacentElement('afterend', legal);
  });
});
